// extracted by mini-css-extract-plugin
export default {"right":"ViewModes_right__jlS51"};